export default __webpack_public_path__ + "static/media/Right-Correct-check.91fe99e5.png";